/**
 * 封装 axios
 */
import axios from 'axios'

// 环境切换
if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = 'https://yunying.server.storkhealthcare.cn'
} else if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = 'https://yunying.server.storkhealthcare.cn'
}

// 设置默认超时时间
axios.defaults.timeout = 10000

// 请求头设置
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

/**
 * 封装 get 请求
 * @param url 请求地址
 * @param params 请求携带参数
 */
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}

/**
 * 封装 get 请求
 * @param url 请求地址
 */
export function getNoParam (url) {
  return new Promise((resolve, reject) => {
    axios.get(url).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}

/**
 * 封装 post 请求
 * @param url 请求地址
 * @param params 请求携带参数
 * @returns {Promise<unknown>}
 */
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}



// WEBPACK FOOTER //
// ./src/request/http.js